import React, { useState } from "react";
import CancelOutlined from "@mui/icons-material/CancelOutlined";
import SwapHorizOutlined from "@mui/icons-material/SwapHorizOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import { Buttons, HeaderButton } from "components";
import Modal from "components/UI/Modal/Modal";
import XGrid from "components/UI/Grid/XGrid";
import { reservasOcupacionModalTitles as titles } from "consts/titulos-de-tablas";
import { ACTIONS } from "consts/Actions";
import {
    isReservaCancelable,
    isCambioHabitacionDisponible,
    isCheckoutDisponible,
} from "pages/hoteles/utils/reservaActions";
import { CancelarReservaModal, CambioHabitacionModal, CheckoutUsuarioModal } from "../reservas/Actions";
import DetallesHuesped from "../detallesHuesped/DetallesHuesped";
import modalStyles from "styles/pages/ModalActions.module.scss";
import { Cached } from "@mui/icons-material";

export default function CellReservasModal({
    open,
    onClose,
    reservas,
    habitacion,
    fechaLabel,
    hotelId,
    onRefresh,
}) {
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const [modalDetails, setModalDetails] = useState({ isOpen: false });

    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    const closeActionModal = () => {
        setModalDetails({ isOpen: false });
    }

    const handleClose = () => {
        setRowSelected({ status: false, row: {} });
        setModalDetails({ isOpen: false });
        onClose();
    };

    const reload = () => {
        onRefresh?.();
    };

    if (!open) return null;

    return (
        <Modal
            wide
            open={open}
            title={`Habitación ${habitacion?.numero ?? ""} — ${fechaLabel}`}
            onClose={handleClose}
        >
            <Modal
                compact={modalDetails.procede !== ACTIONS.DETAIL}
                wide={modalDetails.procede === ACTIONS.DETAIL}
                open={modalDetails.isOpen}
                title={modalDetails.title}
                onClose={closeActionModal}
            >
                {modalDetails.procede === ACTIONS.DETAIL && (
                    <DetallesHuesped huesped={rowSelected.row} />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <CancelarReservaModal
                        reserva={rowSelected.row}
                        updateList={reload}
                        closeModal={closeActionModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <CambioHabitacionModal
                        reserva={rowSelected.row}
                        hotelId={hotelId}
                        updateList={reload}
                        closeModal={closeActionModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.CHECKOUT && (
                    <CheckoutUsuarioModal
                        reserva={rowSelected.row}
                        updateList={reload}
                        closeModal={closeActionModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
            </Modal>

            <div className={modalStyles["detail-modal"]}>
                <div className={`${modalStyles["detail-toolbar"]} ${modalStyles["detail-toolbar-right"]}`}>
                    <Buttons>
                        <HeaderButton
                            text="Actualizar"
                            onClick={reload}
                        >
                            <Cached />
                        </HeaderButton>
                        <HeaderButton
                            text="Detalle del huésped"
                            handleClick={handleClick}
                            data={{
                                title: "Detalles del huésped",
                                procede: ACTIONS.DETAIL,
                            }}
                            disabled={!rowSelected.row.id}
                        >
                            <VisibilityOutlined />
                        </HeaderButton>
                        <HeaderButton
                            text="Cambiar habitación"
                            handleClick={handleClick}
                            data={{
                                title: `Cambiar habitación`,
                                procede: ACTIONS.UPDATE,
                            }}
                            disabled={!isCambioHabitacionDisponible(rowSelected.row)}
                        >
                            <SwapHorizOutlined />
                        </HeaderButton>
                        <HeaderButton
                            text="Cancelar reserva"
                            handleClick={handleClick}
                            data={{
                                title: "Cancelar reserva",
                                procede: ACTIONS.DELETE,
                            }}
                            disabled={!isReservaCancelable(rowSelected.row)}
                        >
                            <CancelOutlined />
                        </HeaderButton>
                        <HeaderButton
                            text="Checkout"
                            handleClick={handleClick}
                            data={{
                                title: "Realizar checkout",
                                procede: ACTIONS.CHECKOUT,
                            }}
                            disabled={!isCheckoutDisponible(rowSelected.row)}
                        >
                            <LogoutOutlined />
                        </HeaderButton>
                    </Buttons>
                </div>
                <div className={modalStyles["detail-grid"]}>
                    <XGrid
                        rows={reservas}
                        titles={titles}
                        secondarySelected={rowSelected}
                        setSecondarySelected={setRowSelected}
                    />
                </div>
            </div>
        </Modal>
    );
}
